import { type FC } from 'react';
import classes from '../styles/index.module.css';
import { closeActiveTooltip } from '../../../../../ReactSharedScripts/components/TooltipBtn';
import { ToolNavigationLinkActiveDot } from '../../../../../ReactSharedScripts/modules/toolNavigation_new/components/ToolNavigationLinkActiveDot';
import RouteLink from '../../../../../ReactSharedScripts/components/RouteLink';

type ToolNavigationCollapsedTooltipLinkProps = {
	url: string;
	title: string;
	onClick?: () => void;
	isActive?: boolean;
	[key: `data-${string}`]: string;
};

export const ToolNavigationCollapsedTooltipLink: FC<ToolNavigationCollapsedTooltipLinkProps> = ({
	url,
	title,
	onClick,
	isActive,
	...dataAttrs
}) => {
	const handleClick = () => {
		onClick?.();
		closeActiveTooltip();
	};

	return (
		<RouteLink
			hasColor={false}
			className={classes.toolNavigation__collapsedTooltipLink}
			href={url}
			onClick={handleClick}
			useDirty
			{...dataAttrs}
		>
			<div className={classes.toolNavigation__collapsedTooltipLinkActiveDotWrapper}>
				{isActive && <ToolNavigationLinkActiveDot />}
			</div>
			{title}
		</RouteLink>
	);
};
